import {Component} from '@angular/core';
import {ToasterConfig} from 'angular2-toaster';
import {HistoryService} from './core/services/history.service';
import {AuthService} from "./core/services/auth.service";

@Component({
  selector: 'app-root',
  moduleId: module.id,
  template: `
    <app-header [title]='title' [subtitle]='subtitle'></app-header>
    <app-nav></app-nav>
    <ngx-loading-bar [includeSpinner]="false" [height]="'4px'" [color]="'#FFFFFF'"></ngx-loading-bar>
    <div class="container-main"><router-outlet></router-outlet></div>
    <app-footer></app-footer>
    <toaster-container [toasterconfig]="toasterconfig"></toaster-container>
  `,
  styles: [`
    body {
      margin: 0 !important;
    }
  `]
})
export class AppComponent {
  public title = 'JPL-ID';
  public subtitle = 'Visits';
  public loggedIn = false;
  public toasterconfig: ToasterConfig =
    new ToasterConfig({
      timeout: {
        error: 5000,
        warning: 5000,
        success: 5000,
        info: 5000
      },
      positionClass: 'toast-bottom-right'
    });

  constructor(historyService: HistoryService, authService: AuthService) {
    this.loggedIn = authService.loggedIn();
  }
}
